import React from 'react';
import { Container, Image, Header, Segment, Divider, Grid, GridRow, ListList, ListItem, List, Tab, Menu } from 'semantic-ui-react';
import { PageTitle } from '../common/PageTitle';

// Creating the bullet points
export const ListDonors = () => (
  <List as='ul'>
    <ListItem as='li'>Florida State University Council for Research and Creativity</ListItem>
    <ListItem as='li'>The University of Cincinnati Office of Research</ListItem>
    <ListItem as='li'>The University of Oklahoma Research Council</ListItem>
    <ListItem as='li'>Texas Tech University</ListItem>
    <ListItem as='li'>a large number of individual donors from around the United States who gave generously through the University of Oklahoma Foundation</ListItem>
  </List>
)

const panes = [
  {
    menuItem: 'Elizabeth Avery',
    render: () => (
      <Tab.Pane>
        <div className="team-profile">
          <Header as="h2" textAlign="center">
            <Image src="/img/elizabeth-avery.png" circular />
            Elizabeth Avery
          </Header>

          <p>
            Elizabeth Avery serves as Associate Dean for Academic Affairs
            and Director of Graduate Studies in the College of Music at
            Florida State University. She joined the FSU faculty in 2023
            following twelve years at the University of Oklahoma, where
            she served as Associate Director/Coordinator of Graduate Studies
            and held the Edith Kinney Gaylord Presidential Professorship.
            Her previous teaching appointments include Indiana University’s
            Jacobs School of Music, Austin Peay State University, Castleton
            State University, and the Crane School of Music.
          </p>

          <p>
            An accomplished collaborative pianist, Avery has performed
            extensively across the United States, Canada, Scandinavia,
            and Europe. Her work includes collaborative performances,
            lecture-recitals, and masterclasses, as well as vocal coaching
            spanning repertoire from early music to contemporary works.
            She has collaborated with leading conductors such as Leonard
            Slatkin, Giancarlo Guerrero, and John Mauceri, and is widely
            recognized for her command of lyric diction and expansive song
            repertoire.
          </p>

          <p>
            As an artist and scholar, Avery is deeply engaged with contemporary
            music, commissioning and premiering new works for voice and piano,
            having brought new performances to such prestigious venues as Weill
            Recital Hall and Steinway Hall in New York City. Her notable
            projects include <em>East Wing Songs</em>, an ongoing series
            of commissioned works by women composers inspired by the
            narratives of U.S. First Ladies, and the recently premiered
            <em>No One Saves the Earth from Us but Us</em>, an innovative song
            cycle by Lisa Neher. Avery also co-founded the Living Song Project,
            an initiative designed to expand access to works by living composers
            through a comprehensive searchable database.
          </p>

          <p>
            Dr. Avery earned the DMA in Piano Accompanying and Chamber Music
            from the Eastman School of Music, the MM in Collaborative Piano
            from the University of Michigan, and the BME from the Crane School
            of Music. She also completed the Special Studies program at the
            Prague Conservatory, performing Czech solo and chamber music while
            refining her expertise in Czech lyric diction.
          </p>
        </div>
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Quinn Patrick Ankrum',
    render: () => (
      <Tab.Pane>
        <div className="team-profile">
          <Header as="h2" textAlign="center">
            <Image src="/img/quinn-new.png" circular />
            Quinn Patrick Ankrum
          </Header>

          <p>
            A champion of new works, Quinn Patrick Ankrum has collaborated
            musically with pianist Elizabeth Avery since 2007. They are
            co-creators of Living Song Project, promoting the art song
            and vocal chamber music of contemporary American composers.
            During the COVID era they used unique technology to rehearse
            and premiere the distanced version of
            <em> No One Saves the Earth from Us but Us</em>, a recently
            commissioned song cycle by Oregon-based composer Lisa Neher,
            setting poetry by Felicia Zamora and Craig Santos-Perez.
            With Avery, she was thrilled to present the world premiere
            of the live version in Cincinnati Song Initiative’s
            “Fellowship of the Song” in May 2025.
          </p>

          <p>
            As an artist, the mezzo soprano has been praised over the
            years for singing with lyrical beauty and compelling artistry.
            She has performed a wide variety of repertoire spanning the
            centuries, in a multitude of venues throughout the United
            States and abroad. Favorite roles include Rosina
            (<em>Il barbiere di Siviglia</em>), Cenerentola
            (<em>La Cenerentola</em>), Zerlina (<em>Le nozze di Figaro</em>),
            Meg (<em>Adamo’s Little Women</em>), and Maddalena
            (<em>Rigoletto</em>). Equally at home on the concert stage,
            favorite works include Bach’s “B Minor” Mass, Mozart’s
            “C Minor” and “Requiem” Masses, Mahler’s
            <em> Lieder eines fahrenden Gesellen</em>, and Handel’s
            <em> Messiah</em>. Recent seasons have included Handel’s
            <em> Messiah</em> with the Lubbock Symphony Orchestra;
            Luciano Berio’s <em>Folksongs</em>, Mahler’s
            <em> Lieder eines fahrenden Gesellen</em>, and Elgar’s
            <em> Sea Pictures</em> with ensembles at the University
            of Cincinnati, College-Conservatory of Music; recitals in Ohio,
            Oklahoma, and New York (Fredonia); and programs of works
            from the Oratorio and American song repertoire in the Lorn
            Live Chamber Music Festival (Oban, Scotland), and in the
            inaugural Sing Northumbria Festival in Northern England.
            She continues to perform eclectic repertoire in diverse venues
            and will sing works by Caroline Shaw and Susan Kander in 2026.
          </p>

          <p>
            Ankrum received her training at Trinity University in San Antonio,
            the University of Colorado at Boulder, and the Eastman School
            of Music, and was a Young Artist in the Glimmerglass Opera Young
            American Artists Program and the Baltimore Opera Studio. She has
            been a Finalist and Winner in numerous Regional and National
            competitions, including the Metropolitan Opera National Council
            auditions (Rocky Mountain Region) and the National Association
            of Teachers of Singing Artist Awards (NATSAA) competition.
            She now serves the profession as an adjudicator when called upon.
          </p>

          <p>
            In addition to her work as an artist, Ankrum is also a lifelong
            educator. She is committed to preventing injury and promoting
            health and wellness in musicians as a Licensed Body Mapping
            Educator and trained Mind-Body facilitator. She is also a
            sought-after voice teacher, and she is honored to teach the
            next generation of artists as they prepare for careers in
            classical music and musical theatre. Having taught at the
            State University of New York College at Fredonia, Texas Tech
            University, and Nazareth College previously, she serves as
            Associate Professor on the Voice Faculty of the University
            of Cincinnati, College-Conservatory of Music in Ohio.
          </p>
        </div>
      </Tab.Pane>
    ),
  },
  {
    menuItem: 'Natalie Sherer',
    render: () => (
      <Tab.Pane>
        <div className="team-profile">
          <Header as="h2" textAlign="center">
            <Image src="/img/natalie-sherer-headshot.png" circular />
            Natalie Sherer
          </Header>

          <p>
            Dynamic pianist <strong>Natalie R. Sherer</strong> thrives in
            collaboration with singers and instrumentalists alike. In January,
            she “made magic [at] the piano” (Seen &amp; Heard International)
            during her Carnegie Hall debut as a performer in SongStudio,
            a program led by acclaimed soprano Renée Fleming that celebrates
            the performance of art song. A frequent recitalist, Sherer
            premiered “Sorrow &amp; Ecstasy: The Complete Songs of Henri Duparc,”
            a semi-staged musical narrative following four characters’
            journeys, and she hosts the CollabPiano Podcast which celebrates
            musical collaboration between singers and pianists in art song.
          </p>

          <p>
            Sherer recently performed with American opera singer Ryan Speedo
            Green at Florida State University where she is Assistant Professor
            of Vocal Coaching &amp; Collaborative Artist. Recent engagements
            include a Guest Artist residency at Orvieto Musica Festival in
            Orvieto, Italy, performances at National Association of Teachers
            of Singing (NATS) National Conferences and Intern Program, SongFest,
            and Sparks &amp; Wiry Cries’ NYC SongSLAM Festival. Sherer is a
            former Collaborative Arts Institute of Chicago (CAIC) Vocal Chamber
            Music Fellow. Following Bachelor of Music and Master of Music
            degrees in Piano Performance through studies at Manhattan School
            of Music, Wheaton College, and Roosevelt University, Sherer earned
            a DMA in Collaborative Piano, studying with renowned pianist
            Martin Katz, from University of Michigan.
            <a href="https://collabpianist.com">collabpianist.com</a>
          </p>
        </div>
      </Tab.Pane>
    ),
  },
];

export const ContentAboutLSP = () => {
  return (
    <React.Fragment>
      <PageTitle title='About Living Song Project' name='about' bgImg='/img/header-about.png'/>
      <Container className='content-main'>
        <p className='jumbotron'>
          Welcome to Living Song Project, a centralized resource for
          the discovery of living American composers and their songs.
          This is a meeting place for performers, composers and
          researchers of contemporary American art song and vocal
          chamber music.
        </p>
        <p>
          Here, a user can browse or search these genres thoroughly 
          and in myriad ways – it is possible to search songs, song 
          cycles, and collections with texts by a single poet or 
          composer, by keyword, composition date, composer’s birth date, 
          and many other parameters. You may find exactly what you’re 
          looking for (for example, a song cycle, under 10 minutes, 
          for soprano, with text by Langston Hughes, written after 1970) 
          or discover something completely unexpected.  In fact, it is 
          the unexpected we hope you will find, and in doing so, you will
           help make known the work of the vast number of current American 
           composers whose work is simply spectacular.
        </p>
        <p>
          We intend for Living Song Project to be a robust and lasting 
          resource, to promote the art song and vocal chamber music 
          compositions of our composers by making their works immediately 
          discoverable and accessible. Your feedback is critical to meeting 
          this goal, so please don’t hesitate to drop us a note if you have 
          a comment or suggestion.
        </p>
        <p>
          Made possible by funding from:

          <ListDonors />
        </p>
        <Divider />
        <Header as='h1'>Meet the Team</Header>
        <p>
          Elizabeth Avery, Quinn Patrick Ankrum, and Natalie Sherer form the core research and creative team behind Living Song Project. Founded by Avery and Ankrum, the project began as an initiative to explore and celebrate the art of song through performance, research, and presentation. This work inspired the mission at the heart of Living Song Project: to create a living connection between composers and performers, championing the vibrant and evolving tradition of contemporary art song. Together, Avery, Ankrum, and Sherer bring passion, scholarship, and artistry to advancing this vision.
        </p>
          <Tab  menu={{ fluid: true, vertical: true, tabular: true }} panes={panes} />
      </Container>
    </React.Fragment>
  );
};
